module.exports = __webpack_public_path__ + "img/jt2.55864586.png";